import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  ogTitle, 
  ogDescription, 
  ogImage,
  canonicalUrl 
}) => {
  const defaultTitle = "Perumal Crane Services Coimbatore | Crane Rental 10-200 Tons";
  const defaultDescription = "Leading crane rental service in Coimbatore. Perumal Crane Services offers professional crane rentals with lifting capacities from 10 to 200 tons at competitive rates. Expert operators, 24/7 service.";
  const defaultKeywords = "crane rental Coimbatore, crane service Coimbatore, Perumal Crane Services, mobile crane rental, tower crane rental, crane hire Coimbatore, heavy lifting equipment, construction crane rental, industrial crane service, crane operators Coimbatore";
  const siteUrl = "https://perumalcraneservices.com";
  const defaultImage = `${siteUrl}/og-image.jpg`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title || defaultTitle}</title>
      <meta name="title" content={title || defaultTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="author" content="Perumal Crane Services" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={`${siteUrl}${canonicalUrl}`} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl} />
      <meta property="og:title" content={ogTitle || title || defaultTitle} />
      <meta property="og:description" content={ogDescription || description || defaultDescription} />
      <meta property="og:image" content={ogImage || defaultImage} />
      <meta property="og:site_name" content="Perumal Crane Services" />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl} />
      <meta property="twitter:title" content={ogTitle || title || defaultTitle} />
      <meta property="twitter:description" content={ogDescription || description || defaultDescription} />
      <meta property="twitter:image" content={ogImage || defaultImage} />
      
      {/* Additional SEO */}
      <meta name="geo.region" content="IN-TN" />
      <meta name="geo.placename" content="Coimbatore" />
      <meta name="geo.position" content="11.0168;76.9558" />
      <meta name="ICBM" content="11.0168, 76.9558" />
      
      {/* Schema.org for Google */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Perumal Crane Services",
          "image": defaultImage,
          "description": "Professional crane rental service in Coimbatore offering hourly, monthly, and project-based crane hire with 10-200 ton capacity. Expert operators, competitive rates, 24/7 availability.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Palladam - Cochin Frontier Road, Chettipalayam",
            "addressLocality": "Coimbatore",
            "addressRegion": "Tamil Nadu",
            "postalCode": "641201",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "11.0168",
            "longitude": "76.9558"
          },
          "url": siteUrl,
          "telephone": "+917639568608",
          "email": "perumalcraneservices@gmail.com",
          "priceRange": "$$",
          "openingHours": "Mo-Su 00:00-23:59",
          "areaServed": {
            "@type": "City",
            "name": "Coimbatore"
          },
          "serviceArea": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": "11.0168",
              "longitude": "76.9558"
            },
            "geoRadius": "50000"
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "150",
            "bestRating": "5",
            "worstRating": "1"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Crane Rental Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Hourly Crane Rental",
                  "description": "Flexible hourly crane rental service in Coimbatore"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Monthly Crane Rental",
                  "description": "Cost-effective monthly crane rental packages in Coimbatore"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Project-Based Crane Rental",
                  "description": "Customized crane rental solutions for specific projects"
                }
              }
            ]
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
